export default "__VITE_ASSET__BosCXMZG__"